import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../index.css";
import logo from "../assets/logo.png.png";

// ─────────────────────────────────────────────────────────────
// HELPER — Ecrire un cookie
// ─────────────────────────────────────────────────────────────
const setCookie = (name, value, days = 1) => {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
 const secure = window.location.protocol === "https:" ? ";Secure" : "";
 document.cookie = `${name}=${encodeURIComponent(value)};expires=${expires};path=/;SameSite=Strict${secure}`;
};

// ─────────────────────────────────────────────────────────────
// TRADUCTIONS
// ─────────────────────────────────────────────────────────────
const translations = {
  fr: {
    tagline:     "Facturation électronique",
    tagline2:    "conforme TEIF & ANCE.",
    description: "Solution certifiée pour la dématérialisation, la signature électronique et l'archivage légal de vos factures en Tunisie.",
    badge:       "✦ Certifié ANCE · Conforme TEIF · Tunisie",
    footer:      "© 2026 · Plateforme de facturation électronique",
    title:       "Accès à votre espace",
    subtitle:    "Connectez-vous pour gérer vos factures électroniques.",
    emailLabel:  "Adresse e-mail professionnelle",
    emailHolder: "nom@entreprise.tn",
    passLabel:   "Mot de passe",
    passHolder:  "••••••••",
    remember:    "Se souvenir de moi",
    btn:         "Se connecter →",
    loading:     "Connexion en cours...",
    forgot:      "Mot de passe oublié ?",
    or:          "ou",
    google:      "Continuer avec Google",
    noAccount:   "Pas encore de compte ?",
    signup:      "Créer un compte",
    ssl:         "🔒 Connexion sécurisée · Données chiffrées",
    errEmpty:    "Veuillez remplir tous les champs.",
    errInactive: "Votre compte n'est pas encore activé. Vérifiez votre e-mail.",
    errLogin:    "Identifiants incorrects. Veuillez réessayer.",
    errServer:   "Impossible de joindre le serveur. Vérifiez votre connexion.",
  },
  ar: {
    tagline:     "الفوترة الإلكترونية",
    tagline2:    "متوافقة مع TEIF و ANCE.",
    description: "حل معتمد لرقمنة الفواتير والتوقيع الإلكتروني والأرشفة القانونية في تونس.",
    badge:       "✦ معتمد ANCE · متوافق مع TEIF · تونس",
    footer:      "© 2026 · منصة الفوترة الإلكترونية",
    title:       "الدخول إلى فضائكم",
    subtitle:    "سجّل دخولك لإدارة فواتيرك الإلكترونية.",
    emailLabel:  "البريد الإلكتروني المهني",
    emailHolder: "اسم@شركة.tn",
    passLabel:   "كلمة المرور",
    passHolder:  "••••••••",
    remember:    "تذكّرني",
    btn:         "→ تسجيل الدخول",
    loading:     "...جارٍ تسجيل الدخول",
    forgot:      "نسيت كلمة المرور؟",
    or:          "أو",
    google:      "المتابعة عبر Google",
    noAccount:   "ليس لديك حساب؟",
    signup:      "إنشاء حساب",
    ssl:         "🔒 اتصال آمن · بيانات مشفّرة",
    errEmpty:    "يرجى ملء جميع الحقول.",
    errInactive: "حسابك لم يُفعَّل بعد. تحقق من بريدك الإلكتروني.",
    errLogin:    "بيانات الدخول غير صحيحة. يرجى المحاولة مجدداً.",
    errServer:   "تعذّر الاتصال بالخادم. تحقق من اتصالك.",
  },
};

function Login() {
  const [email,    setEmail]    = useState("");
  const [password, setPassword] = useState("");
  const [loading,  setLoading]  = useState(false);
  const [showPass, setShowPass] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [lang,     setLang]     = useState("fr");
  const navigate  = useNavigate();
  const canvasRef = useRef(null);
  const [showPassword, setShowPassword] = useState(false);

  const t    = translations[lang];
  const isAr = lang === "ar";

  // ── Particules animées ───────────────────────────────────────
  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx    = canvas.getContext("2d");

    const resize = () => {
      canvas.width  = window.innerWidth;
      canvas.height = window.innerHeight;
    };
    resize();

    const particles = Array.from({ length: 80 }, () => ({
      x:     Math.random() * canvas.width,
      y:     Math.random() * canvas.height,
      r:     Math.random() * 1.8 + 0.4,
      dx:    (Math.random() - 0.5) * 0.4,
      dy:    (Math.random() - 0.5) * 0.4,
      color: Math.random() > 0.5 ? "rgba(99,102,241," : "rgba(14,165,233,",
    }));

    let animId;
    const animate = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      particles.forEach((p, i) => {
        particles.slice(i + 1).forEach((p2) => {
          const dist = Math.hypot(p.x - p2.x, p.y - p2.y);
          if (dist < 120) {
            ctx.beginPath();
            ctx.moveTo(p.x, p.y);
            ctx.lineTo(p2.x, p2.y);
            ctx.strokeStyle = `rgba(99,102,241,${0.1 * (1 - dist / 120)})`;
            ctx.lineWidth   = 0.5;
            ctx.stroke();
          }
        });
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
        ctx.fillStyle = p.color + "0.6)";
        ctx.fill();
        p.x += p.dx;
        p.y += p.dy;
        if (p.x < 0 || p.x > canvas.width)  p.dx *= -1;
        if (p.y < 0 || p.y > canvas.height) p.dy *= -1;
      });
      animId = requestAnimationFrame(animate);
    };
    animate();

    window.addEventListener("resize", resize);
    return () => {
      cancelAnimationFrame(animId);
      window.removeEventListener("resize", resize);
    };
  }, []);

  // ── Login ────────────────────────────────────────────────────
  const handleLogin = async () => {
    setErrorMsg("");
    if (!email || !password) { setErrorMsg(t.errEmpty); return; }
    try {
      setLoading(true);
      const normalizedEmail = email.trim().toLowerCase();
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/login`, {
        method:  "POST",
        headers: { "Content-Type": "application/json" },
        body:    JSON.stringify({ email: normalizedEmail, password }),
      });
      const data = await res.json();
      if (!res.ok) {
        setErrorMsg(res.status === 403 ? t.errInactive : (data.error || t.errLogin));
        return;
      }
      setCookie("token",          data.token,               1);
      setCookie("role",           data.role   || "user",    1);
      setCookie("name",           data.name   || "",        1);
      setCookie("societe_id",     data.societe_id     || "", 1);
      setCookie("societe_folder", data.societe_folder || "", 1);
      setCookie("client_type", data.client_type || "erp", 1);

      const role = data.role || "user";
      if      (role === "super_admin") navigate("/super-admin");
      else if (role === "admin")       navigate("/admin");
      else if (data.needs_societe)     navigate("/societes/new");
      else                             navigate("/home");
    } catch {
      setErrorMsg(t.errServer);
    } finally {
      setLoading(false);
    }
  };

  const handleKeyDown = (e) => { if (e.key === "Enter") handleLogin(); };

  return (
    <div className="login-page" dir={isAr ? "rtl" : "ltr"}>

      {/* ── RESPONSIVE MOBILE STYLES ── */}
      <style>{`
        @media (max-width: 900px) {
          .login-card {
            flex-direction: column !important;
            width: 94vw !important;
            max-width: 480px !important;
            height: auto !important;
            max-height: none !important;
          }
          .login-left {
            width: 100% !important;
            padding: 28px 24px !important;
            min-height: unset !important;
          }
          .login-left-body h1 {
            font-size: 1.3rem !important;
          }
          .login-left-body p {
            font-size: 0.85rem !important;
          }
          .footer-text {
            display: none !important;
          }
          .login-right {
            width: 100% !important;
            padding: 28px 24px !important;
          }
        }
        @media (max-width: 480px) {
          .login-page {
            padding: 12px !important;
          }
          .login-card {
            width: 100% !important;
            border-radius: 14px !important;
          }
          .login-left, .login-right {
            padding: 22px 18px !important;
          }
          .company-logo img {
            max-width: 120px !important;
          }
          .login-right h2 {
            font-size: 1.2rem !important;
          }
          .lang-toggle {
            top: 12px !important;
            right: 12px !important;
            font-size: 0.75rem !important;
            padding: 5px 10px !important;
          }
          .teif-badge {
            font-size: 0.68rem !important;
          }
        }
      `}</style>

      {/* ── CANVAS PARTICULES ── */}
      <canvas
        ref={canvasRef}
        style={{
          position: "fixed", top: 0, left: 0,
          width: "100%", height: "100%",
          zIndex: 0, pointerEvents: "none",
        }}
      />

      {/* ── RETOUR ACCUEIL ── */}
      <button
        style={{
          position: "fixed", top: "20px", left: "24px", zIndex: 99999,
          background: "rgba(255,255,255,0.9)", border: "1.5px solid #E2E8F0",
          borderRadius: 20, padding: "8px 16px", fontSize: "0.8rem", fontWeight: 700,
          color: "#6366f1", cursor: "pointer", fontFamily: "inherit",
          display: "flex", alignItems: "center", gap: 6,
        }}
        onClick={() => navigate("/")}
      >
        ← Accueil
      </button>

      {/* ── CARD ── */}
      <div className="login-card">

        {/* ── LEFT SIDE ── */}
        <div className="login-left">
          <div className="company-logo" onClick={() => navigate("/")} style={{ cursor: "pointer" }}>
            <img src={logo} alt="LOGIMES Logo" />
          </div>

          <div className="login-left-body">
            <h1>{t.tagline}<br />{t.tagline2}</h1>
            <p>{t.description}</p>
            <div className="teif-badge">{t.badge}</div>
          </div>

          <span className="footer-text">{t.footer}</span>
        </div>

        {/* ── RIGHT SIDE ── */}
        <div className="login-right">
          <h2>{t.title}</h2>
          <p className="subtitle">{t.subtitle}</p>

          {/* Erreur */}
          {errorMsg && (
            <div className="error-box">
              <span className="error-icon">!</span>
              {errorMsg}
            </div>
          )}
          {/* Email */}
          <div className="form-group">
            <label>{t.emailLabel}</label>
            <input
              type="email"
              placeholder={t.emailHolder}
              value={email}
              onChange={(e) => { setEmail(e.target.value); setErrorMsg(""); }}
              onKeyDown={handleKeyDown}
              dir="ltr"
            />
          </div>

                {/* Password */}
      <div className="form-group">
        <label>{t.passLabel}</label>
        <div
          style={{
            position: "relative",
            display: "flex",
            alignItems: "center",
          }}
        >
          <input
            type={showPass ? "text" : "password"}
            placeholder={t.passHolder}
            value={password}
            onChange={(e) => { setPassword(e.target.value); setErrorMsg(""); }}
            onKeyDown={handleKeyDown}
            dir="ltr"
            style={{ width: "100%", paddingRight: "42px", boxSizing: "border-box" }}
          />
          <button
            type="button"
            onClick={() => setShowPass(!showPass)}
            tabIndex={-1}
            aria-label={showPass ? "Masquer le mot de passe" : "Afficher le mot de passe"}
            style={{
              position: "absolute",
              [isAr ? "left" : "right"]: "12px",
              top: "50%",
              transform: "translateY(-50%)",
              background: "none",
              border: "none",
              cursor: "pointer",
              fontSize: "1.1rem",
              lineHeight: 1,
              padding: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#64748b",
              zIndex: 2,
            }}
          >
            {showPass ? "🙈" : "👁"}
          </button>
        </div>
      </div>

          <div className="options">
            <label><input type="checkbox" /> {t.remember}</label>
          </div>

          {/* Bouton login */}
          <button className="login-btn" onClick={handleLogin} disabled={loading}>
            {loading ? (<><span className="spinner" />{t.loading}</>) : t.btn}
          </button>

          <Link to="/forgot-password" className="forgot-under">
            {t.forgot}
          </Link>

          <div className="divider">
            <span className="divider-line" />
            <span className="divider-text">{t.or}</span>
            <span className="divider-line" />
          </div>

          {/* Google */}
          <button
            type="button"
            className="email-login"
            onClick={() => { window.location.href = "http://das-cloud.com:5000/api/auth/google"; }}
          >
            <img src="https://cdn-icons-png.flaticon.com/512/300/300221.png" alt="google" />
            {t.google}
          </button>

          <p className="signup">
            {t.noAccount}{" "}
            <Link to="/signup" style={{ color: "#6366f1", textDecoration: "underline" }}>
              {t.signup}
            </Link>
          </p>

          <p className="ssl-notice">{t.ssl}</p>
        </div>

      </div>
    </div>
  );
}

export default Login;